import PasteButton from "@pathwright/ui/src/components/button/PasteButton"
import PropTypes from "prop-types"

const PasteBlockButton = ({
  copiedBlock,
  onPaste,
  index,
  onCancel,
  style = {},
  pasting
}) => {
  const handlePaste = () => onPaste(index)

  // Don't show the button if there's nothing to paste
  if (!copiedBlock) return null

  return (
    <PasteButton
      clip={copiedBlock}
      onPaste={handlePaste}
      onCancel={onCancel}
      style={style}
      styleMode="light"
      pasting={pasting}
    />
  )
}

PasteBlockButton.propTypes = {
  index: PropTypes.number,
  onPaste: PropTypes.func.isRequired, // Async upstream handler handler that calls the pasteBlock mutation
  onCancel: PropTypes.func.isRequired,
  copiedBlock: PropTypes.object,
  style: PropTypes.object
}

export default PasteBlockButton
